import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddressFormTitle = ({ title }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Back button */}
      <IconButton
        onClick={() => navigate(-1)}
        sx={{
          width: '100px',
          height: '40px',
          fontSize: '1.25rem',
          color: 'white',
          margin: '10px 0 20px',
          backgroundColor: '#8E8E8E',
          padding: '2px 10px',
          borderRadius: '8px',

          '&:hover': {
            color: 'white',
            backgroundColor: '#8E8E8E',
            opacity: '.85',
          },
        }}
      >
        <ArrowBackIosIcon
          sx={{
            fontSize: '1rem',
            fontWeight: '400',
            color: 'white',
          }}
        />
        ย้อนกลับ
      </IconButton>

      {/* Title */}
      <Box
        sx={{
          backgroundColor: '#E1000C',
          color: 'white',
          padding: '8px 10px',
          borderRadius: '8px',
          textAlign: 'center',
          marginBottom: '20px',
        }}
      >
        <Typography component={'h1'} sx={{ fontSize: '1.85rem', fontWeight: '500' }}>
          {title}
        </Typography>
      </Box>
    </>
  );
};

export default AddressFormTitle;
